import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/fleets/$id/cloud-storage")({
  staticData: {
    title: "common.cloudStorage",
  },
});
